import Card from './styles';
export default Card;
